import type { NormalizedCacheObject } from "@apollo/client";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import cookie from "js-cookie";

import { createLink } from "lib/apolloClient/httpLink";

import { loginRedirectLink } from "./errorLink";

let apolloClient: ApolloClient<NormalizedCacheObject> | null = null;

export const getApolloClient = (): ApolloClient<NormalizedCacheObject> | null => apolloClient;

export const createBrowserClient = ({
  initialState,
  apiUri,
  apiToken,
}: {
  initialState?: NormalizedCacheObject;
  apiUri?: string;
  apiToken?: string;
}): ApolloClient<NormalizedCacheObject> => {
  const csrfToken = apiToken ?? cookie.get("csrftoken");
  const uri = apiUri ?? process.env.REACT_APP_GRAPHQL_URI;
  const headers = { "X-CSRFToken": `${csrfToken}` };
  const link = createLink(headers, uri);

  apolloClient = new ApolloClient({
    ssrMode: false,
    link: loginRedirectLink.concat(link),
    connectToDevTools: true,
    cache: new InMemoryCache().restore(initialState ?? {}),
  });

  return apolloClient as ApolloClient<NormalizedCacheObject>;
};
